import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TempStorageService {

  /**
   * Sets storage
   */
  setStorage(key: string, item: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(item));
    } catch (error) {
      console.error('Error saving to localStorage', error);
    }
  }

  /**
   * Gets storage
   */
  getStorage<T = any>(key: string): T | undefined {
    const value = localStorage.getItem(key);

    if (!value) {
      return undefined;
    }

    try {
      return JSON.parse(value) as T;
    } catch (error) {
      console.warn(`Invalid JSON in localStorage for key: ${key}`);
      return undefined;
    }
  }

  /**
   * Removes storage
   */
  removeStorage(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Removes list storage for picking
   */
  removeListStorage(keys: string[]): void {
    const filteredKeys = keys.filter(key => key !== environment.userIP);

    filteredKeys.forEach(key => {
      localStorage.removeItem(key);
    });
  }

  /**
   * Removes session storage list
   */
  removeListSession(keys: string[]): void {
    keys.forEach(key => sessionStorage.removeItem(key));
  }
}